import clsx from 'clsx';
import * as React from 'react';
import { observer } from 'mobx-react';
import Modal from '../../../../../Modal';
import Button from '../../../../../Form/Button';
import LearningCollectionStore from '../../Store';
import { T } from '../../../../../../Translations';
import ModalStore from '../../../../../Modal/Store';

export interface Props {
  name: string;
  hideModalStore: ModalStore;
  learningCollectionStore: LearningCollectionStore;
}

const disabled = (learningCollectionStore: LearningCollectionStore): boolean => {
  switch (learningCollectionStore.state.kind) {
    case 'waiting':
    case 'loading':
    case 'error':
    case 'ready':
    case 'publishing':
      return false;
    case 'hide':
      return true;
  }
};

const HideModal: React.FC<Props> = ({ name, hideModalStore, learningCollectionStore }) => {
  switch (hideModalStore.state.kind) {
    case 'closed':
      return <></>;
    case 'open':
      return (
        <Modal
          close={hideModalStore.close}
          title={
            <div className="flex px-4 py-6">
              <h3 className="text-xl font-semibold">
                <T kind="Remove this Collection?" />
              </h3>
            </div>
          }
        >
          <div className="pb-4">
            <p className="text-sm">
              <T kind="<name/> will be removed from the list ..." name={<b>{name}</b>} />
            </p>
            <div className="mt-6 flex justify-end">
              <Button
                type="button"
                value="Cancel"
                disabled={disabled(learningCollectionStore)}
                onClick={hideModalStore.close}
                className={clsx(
                  'cursor-pointer rounded text-sm text-teal-600',
                  'disabled:cursor-wait disabled:opacity-60',
                )}
              />
              <Button
                type="button"
                value="Remove"
                disabled={disabled(learningCollectionStore)}
                onClick={() => {
                  learningCollectionStore.hide(hideModalStore);
                }}
                className={clsx(
                  'ml-5 cursor-pointer rounded bg-rose-600 px-5 py-2.5 text-sm',
                  'text-white disabled:cursor-wait disabled:opacity-60',
                )}
              />
            </div>
          </div>
        </Modal>
      );
  }
};

export default observer(HideModal);
